import { CustomerSessionRefreshed, onCustomerSessionRefresh } from '@otto-ec/fti-customer-session-frontend';

/*                                                                                                    */
/*                                           */
const STORAGE_KEY = 'or_miniBasketAmount';
const EXPIRATION_MS = 300000;

export class MiniBasketAmountStorage {
    private hasCustomerSession = false;

    constructor() {
        onCustomerSessionRefresh.subscribe((event: CustomerSessionRefreshed) => {
            this.hasCustomerSession = event.hasCustomerSession;
            this.save();
        });
        document.addEventListener('basket.changed', () => this.save());
        this.save();
    }

    private save(): void {
        const rawAmount = document.querySelector('.or_js_miniBasketAmount')?.getAttribute('data-minibasketamount');
        const amount = Number(rawAmount);
        if (!rawAmount || isNaN(amount)) {
            return;
        }
        try {
            window.localStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({
                    amount,
                    vid: window.o_util.cookie.get('visitorId'),
                    expire: Date.now() + EXPIRATION_MS,
                    loggedIn: this.hasCustomerSession
                })
            );
        } catch {
            /*                                              */
        }
    }
}
